import { getTheme, setTheme } from "@/services/userSettings";
import { computed, ref } from "vue";
import { useTheme } from "vuetify";
import type { Theme } from "@/configuration/vuetify";

const selectedTheme = ref(getTheme());

// Nuxt UI reads dark mode from a `dark` class on <html>; keep it in sync with
// the Vuetify theme until Vuetify is removed.
function applyDarkClass(theme: Theme) {
  document.documentElement.classList.toggle("dark", theme === "dark");
}
applyDarkClass(selectedTheme.value);

export function useSelectedTheme() {
  const theme = useTheme();

  function setMode(newTheme: Theme) {
    setTheme(newTheme);
    selectedTheme.value = newTheme;
    theme.change(newTheme);
    applyDarkClass(newTheme);
  }

  const isDarkMode = computed(() => selectedTheme.value === "dark");

  return {
    theme: selectedTheme,
    setMode,
    isDarkMode,
  };
}
